import {Children, useCallback} from 'react';
import styled from "styled-components";

import {useFormContext} from "../utils/use_form";

const RadioInputs = styled(({name, Wrapper='div', className, children, childrenStyle, labelStyle}) => {
    const {get, set} = useFormContext();
    const value = get(name);
    const handleChange = useCallback((event) => {
        event.stopPropagation();
        set(name, event.currentTarget.value);
    }, [name, set]);
    return Children.map(children, (child) => {
        if (child.type === 'option') {
            return (
                <Wrapper className={className} style={childrenStyle}>
                    <input
                        type="radio"
                        id={`${name}=${child.props.value}`}
                        name={name}
                        value={child.props.value}
                        checked={value === child.props.value}
                        onChange={handleChange}
                    />
                    <label htmlFor={`${name}=${child.props.value}`} style={labelStyle}>
                        {child.props.children}
                    </label>
                </Wrapper>
            );
        }
        return child;
    });
})``;

export default RadioInputs;
